import { gql } from '@apollo/client';

const TICKET_COUNT_CLINIC_DEVICES_QUERY = gql`
  query countCallCenterDevices($filter: CallCenterDeviceFilterInput!) {
    countCallCenterDevices(filter: $filter)
  }
`;

export default TICKET_COUNT_CLINIC_DEVICES_QUERY;
